import React from 'react';
import withSizes from 'react-sizes';
import { SiteContentWrapper, Container, Row, Col, isSizes } from '~layout';
import { useHasMounted } from '~helpers';
import FeatureContainer from './FeatureContainer';
import Asset from './Asset';
import Description from './Description';
import AsideContainer from './AsideContainer';
import DescriptionContainer from './DescriptionContainer';
import commercePropTypes from '../../prop-types/commercePropTypes';

var ProductFeature = function ProductFeature(_ref) {
  var _aside$asset, _aside$asset2;

  var isFullWidth = _ref.isFullWidth,
      title = _ref.title,
      subtitle = _ref.subtitle,
      alternatePosition = _ref.alternatePosition,
      aside = _ref.aside,
      to = _ref.to,
      ctaLabel = _ref.ctaLabel,
      ctaBtn = _ref.ctaBtn,
      isTablet = _ref.isTablet,
      descriptionColMedia = _ref.descriptionColMedia,
      assetColMedia = _ref.assetColMedia,
      alignItems = _ref.alignItems,
      verticalSpacing = _ref.verticalSpacing,
      descriptionHorizontalSpacing = _ref.descriptionHorizontalSpacing,
      asideHorizontalSpacing = _ref.asideHorizontalSpacing;
  var hasMounted = useHasMounted();
  var descriptionColSize = Object.assign({
    xxs: 28,
    md: 13
  }, descriptionColMedia);
  var assetColSize = Object.assign({
    xxs: 28,
    md: 10
  }, assetColMedia);
  var assetProperties = {
    assetPath: aside === null || aside === void 0 ? void 0 : (_aside$asset = aside.asset) === null || _aside$asset === void 0 ? void 0 : _aside$asset.asset,
    assetHeight: aside === null || aside === void 0 ? void 0 : (_aside$asset2 = aside.asset) === null || _aside$asset2 === void 0 ? void 0 : _aside$asset2.height,
    to: to
  };

  if (!hasMounted) {
    return null;
  }

  var renderFeature = alternatePosition && !isTablet ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, descriptionColSize, /*#__PURE__*/React.createElement(DescriptionContainer, {
    horizontalSpacing: descriptionHorizontalSpacing
  }, /*#__PURE__*/React.createElement(Description, {
    title: title,
    subtitle: subtitle,
    to: to,
    ctaLabel: ctaLabel,
    ctaBtn: ctaBtn
  }))), /*#__PURE__*/React.createElement(Col, assetColSize, /*#__PURE__*/React.createElement(AsideContainer, {
    horizontalSpacing: asideHorizontalSpacing
  }, /*#__PURE__*/React.createElement(Asset, assetProperties), (aside === null || aside === void 0 ? void 0 : aside.composition) && aside.composition))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, assetColSize, /*#__PURE__*/React.createElement(AsideContainer, {
    horizontalSpacing: asideHorizontalSpacing
  }, /*#__PURE__*/React.createElement(Asset, assetProperties), (aside === null || aside === void 0 ? void 0 : aside.composition) && aside.composition)), /*#__PURE__*/React.createElement(Col, descriptionColSize, /*#__PURE__*/React.createElement(DescriptionContainer, {
    horizontalSpacing: descriptionHorizontalSpacing
  }, /*#__PURE__*/React.createElement(Description, {
    title: title,
    subtitle: subtitle,
    to: to,
    ctaLabel: ctaLabel,
    ctaBtn: ctaBtn
  }))));
  return /*#__PURE__*/React.createElement(FeatureContainer, {
    verticalSpacing: verticalSpacing
  }, /*#__PURE__*/React.createElement(SiteContentWrapper, {
    isFullWidth: isFullWidth
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    justifyContent: "center",
    alignItems: alignItems
  }, renderFeature))));
};

var mapSizesToProps = function mapSizesToProps(_ref2, _ref3) {
  var width = _ref2.width;
  var theme = _ref3.theme;
  return {
    isTablet: isSizes.smView({
      width: width
    }, {
      theme: theme
    })
  };
};

ProductFeature.defaultProps = {
  isFullWidth: false,
  title: undefined,
  subtitle: undefined,
  alternatePosition: false,
  to: undefined,
  ctaLabel: undefined,
  ctaBtn: undefined,
  isTablet: false,
  aside: undefined,
  descriptionColMedia: undefined,
  assetColMedia: undefined,
  alignItems: undefined,
  verticalSpacing: 8,
  descriptionHorizontalSpacing: undefined,
  asideHorizontalSpacing: undefined
};
export default withSizes(mapSizesToProps)(ProductFeature);